import { Heading } from '@ui/typography/Heading'

import { SubTitle, Wrapper, ClientImage } from './styles'
import { DescriptionProp } from './types'

export function Description({ title, subtitle, images }: DescriptionProp) {
  return (
    <Wrapper>
      <Heading title={title} />
      <SubTitle>{subtitle}</SubTitle>
      {images?.clientImage && <ClientImage {...images?.clientImage} />}
    </Wrapper>
  )
}
